// src/utils/pdfGenerator.js
import jsPDF from 'jspdf';
import { getPdfDownloadName, getDayLag, flag_line } from '../utils';
import { autoTable } from 'jspdf-autotable'; // Import autoTable function specifically

const alternateColors = alternateRowColorOnLineChange();


export function downloadProdSchedule(tableData, location, workOrder, startDate, endDate, options = {}) {
  // Calculate dynamic page width and margins to maximize usable area
  const pageWidth = 874.89; // A4 landscape width in points (595.28 x 841.89)
  const pageHeight = 655.28; // A4 landscape height in points
  const margin = 5; // Minimal margin for all sides

  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'pt',
    format: 'a4',
  });

  // Store these for use in autoTable
  doc.pageWidth = pageWidth;
  doc.pageHeight = pageHeight;
  doc.margin = margin;

  // Define table headers based on your column structure
  // Dynamically generate headers from columns
  const headers = [
    'Line Name',
    // 'Schedule',

    'Work Order',
    'Item Code',
    'Item Description',
    // 'Change Over',
    // 'Reference',
    // 'Job',
    // 'Item Code',// 7
    // 'Item Description',
    // 'Item Reference',
    // 'Item Work Order',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat',
    'Sun',

    'Total',
    'People'
  ];


  // Adjust font size to fit all columns/data
  doc.setFontSize(3); // Smaller font size for more columns






  // Add willDrawCell hook to highlight the notes cell if it has content
  // Data adaptor: allows you to modify each row before printing
  // const goldColor = [255, 215, 0]; // RGB for gold

  // Group tableData by line_name
  const grouped = {};
  tableData.forEach(row => {
    const line = row.line_name || 'Other';
    if (!grouped[line]) grouped[line] = [];
    grouped[line].push(row);
  });

  const adaptedBody = [];
  Object.keys(grouped).forEach(line => {
    grouped[line].forEach((row) => {
      // Main row - use existing mapping logic
      const adaptedRow = {
        ...row,
        notes: row.notes ? String(row.notes).toUpperCase() : '',
        work_order_id: row.work_order_id ? String(row.work_order_id).split('_').pop() : '',
      };
      const mainRow = headers.map(header => {
        const headerToKey = {
          'Line Name': 'line_name',
          'Work Order': 'work_order_id',
          'Item Description': 'work_order_description',
          'Item Code': 'work_order_code',
          // 'Reference': 'work_order_reference',
          'Schedule': 'starts_at',
          // 'Change Over': 'teardown_label',
          'Job': 'job_number',
          'Notes': 'notes',
          'Mon': 'Mon',
          'Tue': 'Tue',
          'Wed': 'Wed',
          'Thu': 'Thu',
          'Fri': 'Fri',
          'Sat': 'Sat',
          'Sun': 'Sun',
          'Total': 'total',
          'People': 'people'
        };
        return adaptedRow[headerToKey[header]] ?? '';
      });
      adaptedBody.push(mainRow);
      // Sub row - manually create with only ChangeOver and Item Description fields
      const subRow = new Array(headers.length).fill('');
      subRow[1] = row.bulk_item_work_order || '';
      subRow[2] = row.bulk_item_code || '';
      subRow[3] = row.bulk_item_description || '';
      const mon_index = 4;
      // subRow[mon_index] =  row.Mon_h || '';
      // subRow[mon_index+1] =  row.Tue_h || '';
      // subRow[mon_index+2] =  row.Wed_h || '';
      // subRow[mon_index+3] =  row.Thu_h || '';
      // subRow[mon_index+4] =  row.Fri_h || '';
      // subRow[mon_index+5] =  row.Sat_h || '';
      // subRow[mon_index+6] =  row.Sun_h || '';

      // Calculate sum of all day values
      const dayValues = [
        parseInt(row.Mon_a) || 0,
        parseInt(row.Tue_a) || 0,
        parseInt(row.Wed_a) || 0,
        parseInt(row.Thu_a) || 0,
        parseInt(row.Fri_a) || 0,
        parseInt(row.Sat_a) || 0,
        parseInt(row.Sun_a) || 0
      ];



      adaptedBody.push(subRow);



      const subRoweh = new Array(headers.length).fill('');
      // sub row for expected hours to make the pdf look prettier 
      subRoweh[mon_index - 1] = 'Expected Hours'
      subRoweh[mon_index] = row.Mon_h || '';
      subRoweh[mon_index + 1] = row.Tue_h || '';
      subRoweh[mon_index + 2] = row.Wed_h || '';
      subRoweh[mon_index + 3] = row.Thu_h || '';
      subRoweh[mon_index + 4] = row.Fri_h || '';
      subRoweh[mon_index + 5] = row.Sat_h || '';
      subRoweh[mon_index + 6] = row.Sun_h || '';

      adaptedBody.push(subRoweh);

      const subRow2 = new Array(headers.length).fill('');

      const sum = dayValues.reduce((acc, val) => acc + val, 0);
      subRow2[mon_index + 7] = parseInt(sum).toLocaleString();


      subRow2[mon_index - 1] = 'Actual Produced'
      subRow2[mon_index] = row.Mon_a || '';
      subRow2[mon_index + 1] = row.Tue_a || '';
      subRow2[mon_index + 2] = row.Wed_a || '';
      subRow2[mon_index + 3] = row.Thu_a || '';
      subRow2[mon_index + 4] = row.Fri_a || '';
      subRow2[mon_index + 5] = row.Sat_a || '';
      subRow2[mon_index + 6] = row.Sun_a || '';

      adaptedBody.push(subRow2);
      const subRowah = new Array(headers.length).fill('');
      subRowah[mon_index - 1] = 'Actual hours'
      subRowah[mon_index] = row.Mon_ah || '';
      subRowah[mon_index + 1] = row.Tue_ah || '';
      subRowah[mon_index + 2] = row.Wed_ah || '';
      subRowah[mon_index + 3] = row.Thu_ah || '';
      subRowah[mon_index + 4] = row.Fri_ah || '';
      subRowah[mon_index + 5] = row.Sat_ah || '';
      subRowah[mon_index + 6] = row.Sun_ah || '';

      adaptedBody.push(subRowah);



      const subRowcn = new Array(headers.length).fill('');
      // change over and notes 
      // subRowcn[2] = row.notes ? row.notes.substring(0, 30) : ''; 

      // subRowcn[3] = row.notes ? row.notes.substring(30, 60) : ''; 

      subRowcn[mon_index] = row.Mon_c || '';
      subRowcn[mon_index + 1] = row.Tue_c || '';
      subRowcn[mon_index + 2] = row.Wed_c || '';
      subRowcn[mon_index + 3] = row.Thu_c || '';
      subRowcn[mon_index + 4] = row.Fri_c || '';
      subRowcn[mon_index + 5] = row.Sat_c || '';
      subRowcn[mon_index + 6] = row.Sun_c || '';
      // Calculate how much we're behind: target total - actual produced


      // Parse row.total into a proper number, handling various formats
      let targetTotal = 0;
      if (row.total) {
        // Remove any commas, spaces, or non-numeric characters except decimal points
        const cleanTotal = String(row.total).replace(/[^\d.-]/g, '');
        targetTotal = parseFloat(cleanTotal) || 0;
      }
      const actualProduced = [
        parseInt(row.Mon_a) || 0,
        parseInt(row.Tue_a) || 0,
        parseInt(row.Wed_a) || 0,
        parseInt(row.Thu_a) || 0,
        parseInt(row.Fri_a) || 0,
        parseInt(row.Sat_a) || 0,
        parseInt(row.Sun_a) || 0
      ].reduce((acc, val) => acc + val, 0);

      const shortfall = actualProduced - targetTotal;



      adaptedBody.push(subRowcn);

      const subRowdayLag = new Array(headers.length).fill('');
      subRowdayLag[mon_index + 7] = shortfall.toLocaleString();
      // Create arrays for expected quantities and actual produced
      let expectedQuantityArray = [
        parseInt(row.Mon) || 0,
        parseInt(row.Tue) || 0,
        parseInt(row.Wed) || 0,
        parseInt(row.Thu) || 0,
        parseInt(row.Fri) || 0,
        parseInt(row.Sat) || 0,
        parseInt(row.Sun) || 0
      ];

      let actualProducedArray = [
        parseInt(row.Mon_a) || 0,
        parseInt(row.Tue_a) || 0,
        parseInt(row.Wed_a) || 0,
        parseInt(row.Thu_a) || 0,
        parseInt(row.Fri_a) || 0,
        parseInt(row.Sat_a) || 0,
        parseInt(row.Sun_a) || 0
      ];

      // calc and populate the day lag 
      let lagDay = 0; // just an index to iterate through the arrays
      let lags = [];
      const currentDay = new Date().getDay();
      const todayWeekIndex = (currentDay + 6) % 7; // map JS day (Sun=0..Sat=6) to Mon=0..Sun=6
      // Generate lag for each day and add to lags array
      for (let day = 0; day < 7; day++) {
        if (day < todayWeekIndex) {
          const lagValue = getDayLag(expectedQuantityArray, actualProducedArray, day);
          if (lagValue !== '') lags.push(lagValue);
          subRowdayLag[mon_index + day] = lagValue;
        } else {
          subRowdayLag[mon_index + day] = '';
        }
      }

      subRowdayLag[mon_index - 4] = flag_line(lags)
      adaptedBody.push(subRowdayLag);

    });
  });

  // (Removed unused tableOptions variable to fix no-unused-vars error)

  // Add the table to the PDF using the autoTable function
  autoTable(doc, { // Pass the doc object as the first argument
    startY: 30, // Start the table 50 points from the top
    head: [headers], // Wrap headers in an array to represent a single row
    body: adaptedBody,
    theme: 'striped', // Optional: Apply a striped theme
    rowPageBreak: 'avoid', // Avoid breaking rows across pages
    styles: {
      fontSize: 6, // Smaller font size to fit more data
      cellPadding: { top: 0.5, bottom: 0.5, left: 1, right: 1 }, // Slightly reduced padding
      overflow: 'linebreak', // Allow text to wrap within cells
    },
    headStyles: {
      fillColor: [0, 0, 64], // Even darker blue
      textColor: 255,        // White text
      fontSize: 7,
    },
    columnStyles: {
      // Optionally set a max width for each column to help fit all data
      0: { cellWidth: 80 },  // Line Name
      1: { cellWidth: 40 },  // Work Order ID
      2: { cellWidth: 75 },  // CODE/DESCRIPTION
      3: { cellWidth: 150 },  // Reference
      4: { cellWidth: 48 },  // Work Order Reference
      5: { cellWidth: 48 },  // MON
      6: { cellWidth: 48 },  // MON
      7: { cellWidth: 48 },  // MON
      8: { cellWidth: 48 },  // MON
      9: { cellWidth: 48 },  // MON
      10: { cellWidth: 48 },  // MON
      11: { cellWidth: 48 },  // MON
      12: { cellWidth: 48 },
      // 6: { cellWidth: 80 },  // Notes
      // 7: { cellWidth: 60 },  // Notes (increase width to utilize gap between Bulk Item Code and Bulk Description)

      // 8: { cellWidth: 45, cellStyle: { textColor: [255, 0, 0] } },  // Bulk Item Code (red text)
      // 9: { cellWidth: 40, cellStyle: { textColor: [0, 128, 0] } },  // Bulk Description (green text)
      10: { cellWidth: 40, cellStyle: { textColor: [0, 0, 255] } }, // Bulk Ref (blue text)



    },

    didParseCell: function (data) {
      // Main row - make bold
      const TOTAL_ROWS = 7;
      if (data.row.index % TOTAL_ROWS === 0) {
        data.cell.styles.fontStyle = 'bold';
      }

      if (data.row.index % TOTAL_ROWS === 5) {
        data.cell.styles.fontStyle = 'italic';
        data.cell.styles.textColor = [255, 100, 0]; // Very bright orange color - highly readable
      }
      if (data.row.index % TOTAL_ROWS === 3) {
        data.cell.styles.fontStyle = 'italic';
        data.cell.styles.textColor = [0, 100, 0]; // Dark green color - highly readable
      }
      // add row level colors for all the visual changes that we need to include 

      // Apply alternate row coloring based on line_name changes
      alternateColors(data);

      // Highlight lag row in dark red if flagged ('L' placed at column index 3)
      if (data.row.index % TOTAL_ROWS === 6 && data.row.raw && data.row.raw[0] === 'LAG') {
        data.cell.styles.fillColor = [139, 0, 0]; // dark red
        data.cell.styles.textColor = [255, 255, 255]; // white text for contrast
        data.cell.styles.fontStyle = 'bold';
      }
    },
    didDrawPage: function (data) {
      // Add title to each page
      const pageWidth = doc.internal.pageSize.getWidth();
      doc.setFont('Times', 'normal');
      doc.setFontSize(14);
      doc.setTextColor(40);
      doc.text(
        `Weekly Schedule${options?.revision ? ` — Revision ${options.revision}` : ""}`,
        pageWidth / 2,
        22,
        { align: "center" }
      );

      // Add week start date (left-aligned)
      doc.setFontSize(10);
      doc.text(`Week : ${startDate}`, 40, 22, { align: 'left' });
      // Add generated at timestamp (right-aligned)
      doc.setFontSize(9);
      const now = new Date();
      const dateStr = now.toLocaleString();
      doc.text(`Generated at: ${dateStr}`, pageWidth - 40, 22, { align: 'right' });
      doc.setFont('helvetica', 'normal'); // Reset font for table
      doc.setFontSize(7); // Reset font size for table
    }
  });

  const pdf_file_name = getPdfDownloadName(location, workOrder, startDate, endDate) || 'PROD_SCHEDULE.pdf';
  if (options?.returnDoc) {
    return { doc };
  } else {
    doc.save(pdf_file_name);
    return { doc };
  }
}
/**
 * Helper for autoTable: alternate row background color when line_name changes.
 * This function can be used in the autoTable options as the 'didParseCell' hook.
 */
export function alternateRowColorOnLineChange() {
  let lastLineName = ""; // Use empty string instead of "null"
  let currentColorIndex = 0;

  const colors = [
    [255, 255, 255], // white
    [240, 248, 255], // light blue (AliceBlue)
  ];

  return function (data) {



    if (data.section === 'body') {

      if (data.column.index === 0) {
        const lineName = data.row.raw[0]?.trim() || "";

        // console.log("Last:", lastLineName);
        // console.log("Current:", lineName);

        if (lineName !== "" && lineName !== "LAG" && lineName !== lastLineName) {
          currentColorIndex = 1 - currentColorIndex;
          lastLineName = lineName;
          // console.log("✅ New line detected → toggling color:", currentColorIndex);
        } else {
          // console.log("⏭️ Same or empty line → keep color:", currentColorIndex);
        }
      }

      data.cell.styles.fillColor = colors[currentColorIndex];


      // if (data.column.index >= 1 && data.column.index <= 3) {
      //   data.cell.styles.textColor = [139, 0, 0]; // dark red
      // }


      if (data.column.index === 12) {
        data.cell.styles.textColor = [0, 0, 0]; // black
        data.cell.styles.fontStyle = 'bold';
      }
      // if (data.column.index === 4) {
      //   data.cell.styles.textColor = [0, 51, 153]; // dark blue
      //   // data.cell.styles.fontStyle = 'bold';
      // }
    }
  };
}

